import React, { PropsWithChildren } from 'react';
import {
    IconNames,
    IconTooltip as IconTooltipCore,
} from '@instinet-analytics/semantic-ui-components';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';

type IconTooltipProps = PropsWithChildren<{
    containerClassName?: string;
    className?: string;
    maxWidth?: number;
    name?: IconNames;
    title?: string;
}>;

export function IconTooltip(props: IconTooltipProps) {
    const { hideChartHelp } = useSelectAppSettings();

    if (hideChartHelp) {
        return <></>;
    }

    return <IconTooltipCore {...props} />;
}
